import * as Yup from 'yup';
import {UserTypeEnum} from '../common/initialData';

export interface ChargerType extends Record<string, unknown> {
    chargePointId: string;
    chargePointName: string;
    locationId: string;
    modelId: string;
    userId: string;
    companyId: string;
    userType: UserTypeEnum;
}

export const chargerSchema = Yup.object().shape({
    chargePointId: Yup.string().required('schemaRequiredChargePointId').max(255),
    chargePointName: Yup.string().required('schemaRequiredChargePointName').max(255),
    modelId: Yup.string().required('schemaRequiredStationModel'),
    userId: Yup.string().when('userType', {
        is: UserTypeEnum.PRIVATE_DRIVER,
        then: (schema) => schema.required('schemaRequiredClient'),
        otherwise: (schema) => schema.notRequired(),
    }),
    companyId: Yup.string().when('userType', {
        is: UserTypeEnum.COMPANY_USER,
        then: (schema) => schema.required('schemaRequiredClient'),
        otherwise: (schema) => schema.notRequired(),
    }),
});
